import { LOCAL_STORAGE_VAR } from "constants/Common";
import UtilService from "services/util";

const BASE_URL = 'https://crm.mydiamonds.co/event/';

export async function diatrack(formData) {
    var requestOptions = {
        method: "POST",
        body: formData,
        credentials: "include"
    };
    const ref = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-userRef`);
    try {
        await fetch(BASE_URL + "?ref=" + ref, requestOptions);
    }
    catch {}
}

